/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CostLaborCreateCommandFromJSON(json) {
    return CostLaborCreateCommandFromJSONTyped(json, false);
}
export function CostLaborCreateCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'laborName': !exists(json, 'laborName') ? undefined : json['laborName'],
        'laborWorkerId': !exists(json, 'laborWorkerId') ? undefined : json['laborWorkerId'],
        'laborRateMultiplier': !exists(json, 'laborRateMultiplier') ? undefined : json['laborRateMultiplier'],
        'laborHours': !exists(json, 'laborHours') ? undefined : json['laborHours'],
        'laborDate': !exists(json, 'laborDate') ? undefined : (json['laborDate'] === null ? null : new Date(json['laborDate'])),
        'tcardRecordType': !exists(json, 'tcardRecordType') ? undefined : json['tcardRecordType'],
        'tcardNotes': !exists(json, 'tcardNotes') ? undefined : json['tcardNotes'],
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
    };
}
export function CostLaborCreateCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'propertyId': value.propertyId,
        'laborName': value.laborName,
        'laborWorkerId': value.laborWorkerId,
        'laborRateMultiplier': value.laborRateMultiplier,
        'laborHours': value.laborHours,
        'laborDate': value.laborDate === undefined ? undefined : (value.laborDate === null ? null : value.laborDate.toISOString()),
        'tcardRecordType': value.tcardRecordType,
        'tcardNotes': value.tcardNotes,
        'orderNumber': value.orderNumber,
    };
}
